// Hand-maintained registry of behavior-component Stimulus controllers that are
// co-located with their ViewComponents under app/components/**/*_controller.js.
// Imported from the top-level app/javascript/application.js (NOT the
// auto-generated index.js) so `rails stimulus:manifest:update` can't drop it.
// esbuild's --bundle follows these imports into app/components/**.
import { application } from "./application"

import UiDropdownComponentController from "../../components/ui/dropdown_component_controller"
application.register("ui--dropdown", UiDropdownComponentController)

import OnboardingWizardStepComponentController from "../../components/onboarding/wizard_step_component_controller"
application.register("onboarding--wizard-step", OnboardingWizardStepComponentController)

